import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { add } from 'date-fns';
import { IBookingTypes, IStatusTypes } from 'src/app/models/Alert';
import { Notification } from 'src/app/models/AppNotification';

export interface ICustomFilter {
    bookingType: IBookingTypes;
    startDate: Date | null;
    endDate: Date | null;
    status: IStatusTypes;
    airport: string;
}

interface BookingState {
    search: string;
    hasfilterApplied: boolean;
    hasSearchFiltersApplied: boolean;
    resolvedNofication: Notification;
    penddingToBeResolved: boolean;
    customFilter: ICustomFilter;
}

interface UpdatePendingNotification {
    resolvedNofication: Notification | null;
    penddingToBeResolved: boolean;
}

const initialState: BookingState = {
    search: '',

    hasfilterApplied: false,
    hasSearchFiltersApplied: false,

    customFilter: {
        bookingType: 'ALL',
        startDate: new Date(),
        endDate: new Date(),
        status: 'ALL',
        airport: 'ALL',
    },
    resolvedNofication: {} as Notification,
    penddingToBeResolved: false,
};

export const bookingSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        setSearchFilter: (state, action: PayloadAction<string>) => {
            state.search = action.payload;
        },
        setStartDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.startDate = action.payload;
            state.customFilter.endDate = add(action.payload, { days: 6 });
            state.search = '';
            state.hasfilterApplied = true;
        },
        setEndDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.endDate = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setBookingtype: (state, action: PayloadAction<IBookingTypes>) => {
            state.customFilter.bookingType = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setStatusFilter: (state, action: PayloadAction<IStatusTypes>) => {
            state.customFilter.status = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setAirportFilter: (state, action: PayloadAction<string>) => {
            state.customFilter.airport = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        applySearch: (state) => {
            state.hasSearchFiltersApplied = true;
            state.hasfilterApplied = true;

            // reset other fikters to apply search
            state.customFilter.status = 'ALL';
            state.customFilter.bookingType = 'ALL';
            state.customFilter.airport = 'ALL';
            state.customFilter.startDate = new Date();
        },
        updatePendingNotification: (state, action: PayloadAction<UpdatePendingNotification>) => {
            state.resolvedNofication = action.payload.resolvedNofication;
            state.penddingToBeResolved = action.payload.penddingToBeResolved;
        },
        clearAllFilters: (state) => {
            state.hasSearchFiltersApplied = false;
            state.hasfilterApplied = false;

            state.customFilter.status = 'ALL';
            state.customFilter.bookingType = 'ALL';
            state.customFilter.airport = 'ALL';
            state.customFilter.startDate = new Date();
            state.customFilter.endDate = new Date();
        },
    },
});

export const {
    setSearchFilter,
    setAirportFilter,
    setBookingtype,
    setStartDate,
    setEndDate,
    setStatusFilter,
    applySearch,
    clearAllFilters,
    updatePendingNotification,
} = bookingSlice.actions;
export default bookingSlice.reducer;
